// We keep our own version of this class for two reasons:
// 1.) It's used in our property worker (both directly and via InstanceTreeStorage) and we cannot use LMV imports there.
// 2.) We need to use this class stand-alone (see DtModel), which is not possible with the LMV version.
// So this is a Tandem-specific implementation, but it also works with LMV
// (when sharing the names array with InstanceTreeAccess).

import { utf16to8, utf16to8Length, utf8BlobToStr } from "../dt/encoding/utf8";

function arrayToIntBuffer(a, maxVal) {
  let b;
  if (maxVal < 256) {
    b = new Uint8Array(a.length);
  } else if (maxVal < 65536) {
    b = new Uint16Array(a.length);
  } else {
    b = new Uint32Array(a.length);
  }

  b.set(a);
  return b;
}

export class FlatStringStorage {

  constructor(initial) {
    if (initial) {
      this.buf = initial.buf;
      this.idx = initial.idx;
      this.next = initial.next;
      this.names = initial.names;
    } else {
      this.buf = new Uint8Array(256);
      this.next = 0;
      this.idx = [0];
      this.names = [];
      this.s2i = new Map();
      this.maxIdx = 0;
    }
  }

  allocate(len) {
    if (this.buf.length - this.next < len) {
      var nsz = Math.max(this.buf.length * 3 / 2, this.buf.length + len);
      var nb = new Uint8Array(nsz);
      nb.set(this.buf);
      this.buf = nb;
    }
  }

  add(s, id) {
    let idx = this.s2i.get(s);

    if (idx !== undefined) {
      this.names[id] = idx;
      return idx;
    }

    if (s === null || typeof s === "undefined") {
      idx = 0;
    } else if (!s.length) {
      this.idx.push(this.next);
      idx = this.idx.length - 1;
    } else {
      var len = utf16to8Length(s);
      this.allocate(len);
      this.next += utf16to8(s, this.buf, this.next);
      this.idx.push(this.next);
      idx = this.idx.length - 1;
    }

    this.names[id] = idx;
    this.s2i.set(s, idx);

    if (this.maxIdx < idx) {
      this.maxIdx = idx;
    }

    return idx;
  }

  get(i) {
    if (!i) {
      return undefined;
    }

    let start = this.idx[i - 1];
    let end = this.idx[i];
    if (start === end)
    return "";
    return utf8BlobToStr(this.buf, start, end - start);
  }

  getById(id) {
    return this.get(this.names[id]);
  }

  /** If the ID would return a non-empty string. */
  hasById(id) {
    let i = this.names[id];
    return i && this.idx[i - 1] !== this.idx[i];
  }

  isEmpty() {
    return this.next == 0;
  }

  flatten() {
    this.s2i = null;
    this.idx = arrayToIntBuffer(this.idx, this.next);
    this.names = arrayToIntBuffer(this.names, this.maxIdx);
  }

  addTransferBuffers(transferList) {
    transferList.push(this.idx.buffer);
    transferList.push(this.names.buffer);
  }
}